import { render, staticRenderFns } from "./AccountingConfigList.vue?vue&type=template&id=c6a07fa2&"
import script from "./AccountingConfigList.vue?vue&type=script&lang=js&"
export * from "./AccountingConfigList.vue?vue&type=script&lang=js&"
import style0 from "./AccountingConfigList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports